import applications from "./applications";

export const APPLICATION_NAMESPACE = "applications";

export default applications;
